import Item from "@/model/item";
import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import ItemApi from "@/api/itemApi";
import PaginateModel from "@/model/paginate";

@Module({ namespaced: true })
export default class ItemModule extends VuexModule {
  Items: Item[] = [];
  paginate: PaginateModel;
  @Mutation
  setItems(Items: Item[]): void {
    this.Items = Items;
  }
  @Mutation
  setPaginate(paginate: PaginateModel): void {
    this.paginate = paginate;
  }
  @Action({ rawError: true })
  async fetchItemList(query: any): Promise<void> {
    const { list, paginate } = await ItemApi.getAllItems(query);
    this.context.commit("setItems", list);
    this.context.commit("setPaginate", paginate);
  }

  get getItems(): Item[] {
    return this.Items;
  }
  get getPaginate(): PaginateModel {
    return this.paginate;
  }
}
